import { Component, OnInit,Inject } from '@angular/core';
import { UntypedFormGroup,UntypedFormControl, Validators} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ErrorMessages } from 'src/app/shared/common/errormessages';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { VaultobjectattributeserviceService } from '../../vaultobjectattributes/vaultobjectattributesservice/vaultobjectattributeservice.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MatSnackBar } from '@angular/material/snack-bar';
import { validationmethod } from 'src/app/shared/models/validationmethod';
import { VaultObjectRelationshipService } from 'src/app/shared/services/vault-object-relationship.service';
import { ReportingServiceService } from 'src/app/shared/services/reporting-service.service';
  export interface FormData {
    rowData: any;
    dnsId:any;
  }
@Component({
    selector: 'app-vault-object-relationship-popup',
    templateUrl: './vault-object-relationship-popup.component.html',
    styleUrls: ['./vault-object-relationship-popup.component.scss'],
    standalone: false
})
export class VaultObjectRelationshipPopupComponent implements OnInit {

  formValid: UntypedFormGroup;
  formValidCheckbox: UntypedFormGroup;
  isCheckboxSelected=false;
  backgroundColorButton;
  allocateButtonsBoolean = false;
  allocateButtons1Boolean=true;
  objectsList;
  validation_messages;
  objectNameValue;
  parentObjectNameValue;
  showCreateAnother=true;
  buttonName="Save"
  vaultObjectRelationshipObject={
    id:'',
    objectName:'',
    parentObjectName:"",
    uniqueKeyColumn:"",
    columnsFromParentFile:"",
    parentRefColumn:'',
    dnsId:'',
    childFileName:'',
    parentFileName:'',
    uniquekeycolumnd2dvalidation:'',
    migrationid:0,
    refcolmapping:'',
    primarycolumn:''

  }
  dnsId: any;
  constructor(
    private localStorageSettings: LocalStorageSettingsService,
    private dialogref: MatDialogRef<VaultObjectRelationshipPopupComponent>,
    private errormessages: ErrorMessages,
    private vaultobjectattributeserviceService : VaultobjectattributeserviceService,
    private spinner: NgxUiLoaderService,
    private snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: FormData,
    private validation: validationmethod,
    private vaultObjectRelationshipService:VaultObjectRelationshipService,
    private reportingServiceService:ReportingServiceService,
    ) {
      this.validation_messages = this.errormessages.vaultObjectRelationship;
      // console.log(this.data.rowData);
      if(this.data){
        console.log(this.data.dnsId)
        if(this.data.rowData){
          console.log(this.data.rowData)
          this.dnsId = this.data.dnsId;
          console.log(this.dnsId)
          this.vaultObjectRelationshipObject=this.data.rowData;
          this.showCreateAnother=false
          this.buttonName="Update"
          console.log(this.vaultObjectRelationshipObject);
        }else{
          console.log("inside else **************************************")
          console.log(this.data.dnsId)
          this.showCreateAnother=true
          this.buttonName="Save"
          this.vaultObjectRelationshipObject.dnsId=this.data.dnsId;
          console.log(this.vaultObjectRelationshipObject.dnsId)
        }
      }
      this.backgroundColorButton = this.localStorageSettings.getSettings("ColorA");
    console.log(this.backgroundColorButton);


    }

  ngOnInit(): void {
    this.formValid = new UntypedFormGroup({
      objectName: new UntypedFormControl("", [
        Validators.required,
      ]),
      parentObjectName: new UntypedFormControl("", [
        Validators.required,
      ]),
      uniqueKeyColumn: new UntypedFormControl("", [
        Validators.required, this.validation.noWhitespaceValidator,this.validation.specialCharacterValidator
      ]),
      columnsFromParentFile: new UntypedFormControl("", [
        Validators.required, this.validation.noWhitespaceValidator,this.validation.specialCharacterValidator
      ]),
      parentRefColumn: new UntypedFormControl("", [
        Validators.required, this.validation.noWhitespaceValidator,this.validation.specialCharacterValidator
      ]),
      parentFileName: new UntypedFormControl("", [
        Validators.required, this.validation.noWhitespaceValidator,this.validation.specialCharacterValidator
      ]),
      childFileName: new UntypedFormControl("", [
        Validators.required, this.validation.noWhitespaceValidator,this.validation.specialCharacterValidator
      ]),
      uniquekeycolumnd2dvalidation: new UntypedFormControl("", []),
      refcolmapping: new UntypedFormControl("",[]),
      primarycolumn: new UntypedFormControl("",[])
    });
    this.formValidationsCheckbox();
    this.getObjectMetadataList();

  }
  formValidationsCheckbox() {

    // form validations
    this.formValidCheckbox = new UntypedFormGroup({
      isCheckboxSelected: new UntypedFormControl("")
    });
  }
  getObjectMetadataList(){
    this.spinner.start()
    this.vaultobjectattributeserviceService.retrieveobjectsByDnsidforObjectRelationship(this.data.dnsId).subscribe(res => {

      console.log(res);
      if(res.error == true){
        this.snackBar.open(res.statusMessage, "OK", { duration: 5000 });
      }else{
        this.objectsList=res;
        this.objectsList = this.objectsList.sort((a, b) => (a.objectname < b.objectname) ? -1 : 1 );
        console.log(this.objectsList);

        for(let i=0;i<this.objectsList.length;i++){
          this.objectsList[i]["isDisabledObject"]=false
          this.objectsList[i]["isDisabledParentObject"]=false
          if(this.data.rowData){
            if(this.objectsList[i].objectname == this.data.rowData.objectName){
              this.objectNameValue=this.objectsList[i].id
              this.objectsList[i].isDisabledParentObject=true
              this.objectsList[i].isDisabledObject=false
            }
            if(this.objectsList[i].objectname == this.data.rowData.parentObjectName){
              this.parentObjectNameValue=this.objectsList[i].id
              this.objectsList[i].isDisabledParentObject=false
              this.objectsList[i].isDisabledObject=true
            }
          }
        }

      }
      this.spinner.stop();
    });
  }

  closeFunction() {

    //Making isCheckboxSelected to false. To close the popup.
    this.isCheckboxSelected = false;

    this.close(false);

  }
  close(reload){
    this.dialogref.close(reload);
  }
  onObjectNameChange(event){
    console.log(event);
    if(event){
      for(let i=0;i<this.objectsList.length;i++){
        if(this.objectsList[i].id==event){
          this.vaultObjectRelationshipObject.objectName=this.objectsList[i].objectname
          this.objectsList[i].isDisabledParentObject=true
        }else{
          this.objectsList[i].isDisabledParentObject=false
        }
      }
    }

  }
  onparentObjectNameChange(event){
    if(event){
      for(let i=0;i<this.objectsList.length;i++){
        if(this.objectsList[i].id==event){
          this.vaultObjectRelationshipObject.parentObjectName=this.objectsList[i].objectname
          this.objectsList[i].isDisabledObject=true
        }else{
          this.objectsList[i].isDisabledObject=false
        }
      }
    }
  }

  sendDataAndClose(){
    if (!this.formValid.valid) {
      this.validation.getvalidationmessage();
      this.formValid.get("objectName").markAsTouched();
      this.formValid.get("parentObjectName").markAsTouched();
      this.formValid.get("uniqueKeyColumn").markAsTouched();
      this.formValid.get("columnsFromParentFile").markAsTouched();
      this.formValid.get("parentRefColumn").markAsTouched();
      this.formValid.get("parentFileName").markAsTouched();
      this.formValid.get("childFileName").markAsTouched();
      return;
    } else {
      console.log(this.vaultObjectRelationshipObject);
      if(this.showCreateAnother){
        this.spinner.start()
        this.vaultObjectRelationshipService.insertVaultObjectRelationship(this.vaultObjectRelationshipObject).subscribe(res=>{
          if(res.error){
            this.spinner.stop();
            this.snackBar.open(res.statusMessage, "OK", { duration: 5000 });
          }else{
            this.spinner.stop();
            this.snackBar.open(res.statusMessage, "OK", { duration: 5000 });
            if(!this.isCheckboxSelected){
               this.close(true);
            }else{
              let empty={
                id:'',
                objectName:'',
                parentObjectName:"",
                uniqueKeyColumn:"",
                columnsFromParentFile:"",
                parentRefColumn:'',
                dnsId:'',
                childFileName:'',
                parentFileName:'',
                uniquekeycolumnd2dvalidation:'',
                migrationid:0,
                refcolmapping:'',
                primarycolumn:''
              }
              this.vaultObjectRelationshipObject=empty;
              this.objectNameValue=''
              this.parentObjectNameValue=''
              this.formValid.reset();
            }
          }
        })
      }else{
        this.spinner.start()
        this.vaultObjectRelationshipService.updateVaultObjectRelationship(this.vaultObjectRelationshipObject).subscribe(res=>{
          if(res.error){
            this.spinner.stop();
            this.snackBar.open(res.statusMessage, "OK", { duration: 5000 });
          }else{
            this.spinner.stop();
            this.snackBar.open(res.statusMessage, "OK", { duration: 5000 });
            this.close(true);
          }
        })
      }
    }

    // this.snackBar.open("Record Insertion inprogress", 'OK', {duration: 5000});
  }
}
